import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { MessageCompleteTemplate } from 'components/Templates'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { PublishStatus } from 'types/message'

const MessageComplete: FC = () => {
  const search = useSelector((state: State) => state.router.location.search)
  const publishStatus = search.split('?publishStatus=')[1] as PublishStatus
  return (
    <Layout title={'メッセージ配信'}>
      <MessageCompleteTemplate publishStatus={publishStatus} />
    </Layout>
  )
}

export default MessageComplete
